export default function Experience() {
  return (
    <section id="experience">
      <h1>My Resume</h1>
      <h3>Experience & Certifications</h3>
      <div id="experience-div">
        <div className="card-container-1">
          <div id="division1"></div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">Senior Web Developer</h2>
              <h4 className="card-subtext">
                Transcendental (May 2023 - Present)
              </h4>
              <p className="card-para">
                Skills: Website & Domain Management, Website Development,
                Component/Template builds, Client Website Transfers & Edits,
                Client Application, HTML, CSS, JS, REACT
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">Full Stack Web Developer</h2>
              <h4 className="card-subtext">
                Community Bible Church (Jun 2022 - May 2023)
              </h4>
              <p className="card-para">
                Skills: Website & Domain Management, AWS Administrator, UX/UI
                Designer, HTML, CSS, JS, REACT, PHP Developer
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">
                Full Stack Web Developer & Junior IT Technician
              </h2>
              <h4 className="card-subtext">Freelance (2017 - Present)</h4>
              <p className="card-para">
                Skills: Data Recovery, Network Setup & Configuration, PC
                Maintenance, Website Management & Development, HTML, CSS,
                BOOTSTRAP, JS, REACT, Python
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">Cybersecurity & Web Design Teacher</h2>
              <h4 className="card-subtext">
                Southwest ISD (Aug 2021 - Aug 2022)
              </h4>
              <p className="card-para">
                Skills: Developed CompTIA ITF & CompTIA A+ Aligned Trainings for
                Secondary Students, CyberPatriot Sponsor, Taught Amazon
                ProjectSTEM Python Curriculum{" "}
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">Web Developer & Graphic Designer</h2>
              <h4 className="card-subtext">
                Codeup, LLC (Mar 2020 - Aug 2020)
              </h4>
              <p className="card-para">
                Skills: Website Management & Maintainance, Designed Graphics for
                Web & Social Media, Designed Billboards & Merchandise
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">Web Design & Animation Teacher</h2>
              <h4 className="card-subtext">
                New Braunfels ISD (Aug 2017 - Aug 2021)
              </h4>
              <p className="card-para">
                Skills: Developed Web Design Curriculum, Developed Animation I -
                Practicum of Animation Curriculum, Business Professional of
                America Lead Advisor for District, Managed & Maintained A
                Computer Lab, HTML, CSS, JS, BOOTSTRAP
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-ghost"></i>
            <div className="card-box">
              <h2 className="card-title">U.S. Army Military Police 31B</h2>
              <h4 className="card-subtext">
                United States Army (Feb 2009 - Feb 2014)
              </h4>
              <p className="card-para">
                Skills: Communicated with A Diverse Populus, Defended Federal &
                State Laws, Prepared Written & Oral Reports, Obtained A Warrior
                Leader Course Certificate, Secured & Upheld A Secret Clearance
              </p>
            </div>
          </div>
        </div>
        <div className="card-container-2">
          <div id="division2"></div>
          <div className="card">
            <i className="fa-solid fa-user-graduate"></i>
            <div className="card-box">
              <h2 className="card-title">Full Stack Coding Bootcamp</h2>
              <h4 className="card-subtext">
                University of Texas at Austin (Oct 2021 - Apr 2022)
              </h4>
              <p className="card-para">
                Full MERN Stack (MongoDB * Express * React.js * Node.js)
              </p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-user-graduate"></i>
            <div className="card-box">
              <h2 className="card-title">Bachelor's in Fine Arts</h2>
              <h4 className="card-subtext">
                The Art Institute of San Antonio (2014 - 2017)
              </h4>
              <p className="card-para">Video Production & Filmmaking</p>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-scroll"></i>
            <div className="card-box">
              <h2 className="card-title">CompTIA IT Fundamentals (ITF+)</h2>
              <h4 className="card-subtext">Credential ID: COMP001022059238</h4>
              <a
                href="https://www.credly.com/badges/7ceb21ff-d90e-47a6-8a53-3750bf720d35?source=linked_in_profile"
                className="card-para">
                View credential
              </a>
            </div>
          </div>
          <div className="card">
            <i className="fa-solid fa-scroll"></i>
            <div className="card-box">
              <h2 className="card-title">EC-12 242 Technology Applications</h2>
              <h4 className="card-subtext">
                Texas Education Agency (Search: Paul Michael Vera)
              </h4>
              <a
                href="https://tealprod.tea.state.tx.us/ECOS-External/EcosOnline/VirtCert#current"
                className="card-para">
                View credential
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
